import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  TextField,
  Button,
  Typography,
} from "@mui/material";

export default function PopupEventWts({ open, onClose, onSubmit, image }) {
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");

  const [errors, setErrors] = useState({
    fullName: "",
    phone: "",
  });

  const validateFullName = (value) => {
    if (!value) return "Le nom est requis.";
    if (value.length < 3) return "Min 3 caractères.";
    return "";
  };

  const validatePhone = (value) => {
    if (!value) return "Le numéro est requis.";

    // Supprimer les espaces
    const cleaned = value.replace(/\s+/g, "");

    // Vérifier uniquement des chiffres, longueur 8 à 12
    const regex = /^(?:\+212|0)([6-7])[0-9]{8}$/;

    if (!regex.test(cleaned)) {
      return "Numéro invalide : 8 à 13 chiffres uniquement.";
    }

    return "";
  };

  const handleSubmit = () => {
    const fullNameError = validateFullName(fullName);
    const phoneError = validatePhone(phone);
    setErrors({ fullName: fullNameError, phone: phoneError });
    if (fullNameError || phoneError) return;
    onSubmit({ fullName, phone });
  };

  const handleClose = () => {
    setFullName("");
    setPhone("");
    setErrors({ fullName: "", phone: "" });
    onClose();
  };

  const isFormValid = !validateFullName(fullName) && !validatePhone(phone);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        Vérifiez votre photo et entrez vos informations pour récupérer sur
        whatsapp
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={3}>
          {/* LEFT IMAGE */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: "100%",
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#000",
              }}
            >
              {image ? (
                <Box
                  component="img"
                  src={image}
                  alt="Photo"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    maxHeight: 380,
                  }}
                />
              ) : (
                <Typography
                  sx={{ color: "#9ca3af", py: 6, textAlign: "center" }}
                >
                  Aucune image disponible
                </Typography>
              )}
            </Box>
          </Grid>

          {/* RIGHT FORM */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Nom complet"
              fullWidth
              margin="normal"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              error={Boolean(errors.fullName)}
              helperText={errors.fullName}
            />

            <TextField
              label="Téléphone"
              fullWidth
              type="number"
              margin="normal"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              inputProps={{ inputMode: "tel" }}
              error={Boolean(errors.phone)}
              helperText={errors.phone}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Annuler
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          disabled={!isFormValid}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
